import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from "../card/Card";
import "./MovieList.scss";

const MovieList = () => {

	//const API_URL = process.env.REACT_APP_API_URL;

	//const API_KEY = process.env.REACT_APP_API_KEY;
	const [ movieList, setMovieList ] = useState([]);
	const { type } = useParams();

	useEffect(() => {
		getData();
	}, [ type ]);


	// https://api.themoviedb.org/3/movie/${ type ? type : "popular" }?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US

	// useParams - type - popular
	const getData = () => {
		fetch(`https://api.themoviedb.org/3/movie/${ type ? type : "popular" }?api_key=06cc335abc6769f2ba982c824990faeb&language=en-US`)
			.then(res => res.json())
			.then(data => setMovieList(data.results));
	};


	return (
		<div>
			<div className="movie__list">
				<h2 className="list__title">{ (type ? type : "Popular").toUpperCase() }</h2>
				<div className="list__cards">
					{/* COMPONENT CARD */ }
					{
						movieList.map(movie => (
							<Card movie={ movie } />
						))
					}
				</div>
			</div>
		</div>
	);
};

export default MovieList;
